// src/components/HUD/HUDScriptAssistant.js
// Floating HUD Script Builder panel — mirrors RpaAgentChatMini.js pattern.
// Shown only on /hud routes instead of the generic ChatbotMini.
import React, { useState } from 'react';
import HUDScriptAssistantLogic from './HUDScriptAssistantLogic';

const HUDScriptAssistant = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{
      position: 'fixed',
      bottom: 20,
      right: 20,
      zIndex: 1000,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: 8,
    }}>
      {/* Toggle button */}
      <button
        onClick={() => setIsOpen(v => !v)}
        title={isOpen ? 'Close Script Builder' : 'Open ACL Script Builder'}
        style={{
          width: 52,
          height: 52,
          borderRadius: '50%',
          background: isOpen ? '#5F5E5A' : '#1D9E75',
          color: '#fff',
          border: 'none',
          cursor: 'pointer',
          fontSize: 22,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 12px rgba(0,0,0,0.18)',
          transition: 'background 0.2s',
        }}
      >
        {isOpen ? '✕' : '⚙️'}
      </button>

      {/* Chat panel */}
      {isOpen && (
        <div style={{
          position: 'absolute',
          bottom: 62,
          right: 0,
          width: 420,
          maxHeight: '80vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 4px 24px rgba(0,0,0,0.15)',
          border: '1px solid #E2E0D8',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}>
          <HUDScriptAssistantLogic onClose={() => setIsOpen(false)} />
        </div>
      )}
    </div>
  );
};

export default HUDScriptAssistant;